// ../data/Hero.js

const HERO_IMAGE = `${process.env.PUBLIC_URL}/assets/hero_banner.jpg`;

const HERO_TITLE = 'Your Cargo, Our Priority';

const HERO_SUBTITLE = 'Trusted logistics partner for customs brokerage, freight forwarding, customs representation, and cross-border solutions based in Dubai.';

const HERO_CHIPS = [
  'Customs brokerage',
  'Air & Sea Freight',
  'Transit & Transshipment',
  'Land Transport',
];

export {
  HERO_IMAGE,
  HERO_TITLE,
  HERO_SUBTITLE,
  HERO_CHIPS,
};
